import { HttpClient } from "@angular/common/http";
import { Component, ChangeDetectionStrategy, Inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { env } from "../../../../../env/env";
import * as uuid from 'uuid';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'add-invite-code-dialog',
  templateUrl: 'add-invite-code-dialog.html',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatIconModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddInviteCodeDialog {
  //readonly dialogRef = inject(MatDialogRef<AddInviteKeyDialog>);
  public inviteCode: string = ''

  constructor(
    private clipboard: Clipboard,
    private httpClient: HttpClient,
    private dialogRef: MatDialogRef<AddInviteCodeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { instanceId: string }) {
    this.inviteCode = uuid.v4();
  }
  public closeDialog(): void {
    this.dialogRef.close(false);
  }

  public saveInviteCode(): void {
    this.httpClient.post(`${env.apiUrl}/app-instances/${this.data.instanceId}/invite-codes`, { code: this.inviteCode }).subscribe({
      next: s => {
        alert('successfully added invite code');
        this.dialogRef.close(true);
      }
    })
  }

  public copyToClipboard(): void {
    this.clipboard.copy(this.inviteCode);
  }
}